import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CreateAccountComponent } from '../create-account/create-account.component';

@Component({
  selector: 's18-kick-putt',
  templateUrl: './kick-putt.component.html',
  styleUrls: ['./kick-putt.component.scss']
})
export class KickPuttComponent implements OnInit {

  constructor(
    private dialog: MatDialog,
    private router: Router
  ) { }

  ngOnInit() {
    
  }

  showRegistrationDialog(){
    let dialogRef = this.dialog.open( CreateAccountComponent, {
      width: '350px',
      data: {
        source: 'tryitfree'
      }
    });

    dialogRef.afterClosed().subscribe( resp => {
      if ( resp ){
          this.router.navigateByUrl("/dashboard/tryitfree");;
      }
    });
  }
}
